













































































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import dayjs from 'dayjs'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewOrders extends Vue {
  headers = [
    { text: 'Policy Code', value: 'insuranceCode' },
    { text: 'Order Date', value: 'createdAt' },
    { text: 'Status', value: 'status' },
    { text: 'Grant Total', value: 'grandTotal' },
    { text: 'Loca User', value: 'customer' },
    { text: 'Type', value: 'insuranceType' },
    { text: 'Profile', value: 'profile' },
    { text: '', value: 'action' }
  ]

  items = []

  created () {
    this.fetchOrders()
  }

  async fetchOrders () {
    try {
      const { data } = await axiosInstance.get('/portal/insurance/orders')
      this.items = data.data.map((item: any) => {
        return {
          id: item.id,
          insuranceType: item.insurance_type,
          insuranceCode: item.insurance_code,
          createdAt: dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss'),
          status: item.status,
          grandTotal: item.grand_total,
          customerUUID: item.customer_uuid,
          customerName: item.customer_name,
          customerTel: item.customer_tel,
          healthFirstName: item.health_first_name,
          healthLastName: item.health_last_name,
          healthTel: item.health_tel,
          healthGender: item.health_gender,
          vehicleBrand: item.vehicle_brand,
          vehicleModel: item.vehicle_model,
          vehicleLicensePlate: item.vehicle_license_plate
        }
      })
    } catch (error) {
      showHttpErrorAlert(error)
    }
  }
}
